var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlumbingSystemActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#8FB16A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.1395 73.4844C51.5974 73.4809 48.2014 72.0723 45.6967 69.5677C43.1921 67.0631 41.7835 63.6671 41.7801 60.125V53.6504C41.7788 52.8596 41.4641 52.1015 40.9048 51.5424C40.3455 50.9834 39.5873 50.6689 38.7965 50.6679H23.7039V40.2922H38.7988C42.3408 40.2959 45.7367 41.7046 48.2412 44.2091C50.7458 46.7137 52.1545 50.1096 52.1582 53.6515V60.125C52.1582 60.916 52.4724 61.6746 53.0317 62.2339C53.5911 62.7932 54.3497 63.1074 55.1406 63.1074C55.9316 63.1074 56.6902 62.7932 57.2495 62.2339C57.8088 61.6746 58.1231 60.916 58.1231 60.125V28.1058H68.4988V60.125C68.4954 63.6671 67.0868 67.0631 64.5822 69.5677C62.0776 72.0723 58.6815 73.4809 55.1395 73.4844Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9793 38.7981H23.5176C23.0807 38.7981 22.7266 39.1522 22.7266 39.5891V51.1497C22.7266 51.5865 23.0807 51.9407 23.5176 51.9407H26.9793C27.4162 51.9407 27.7703 51.5865 27.7703 51.1497V39.5891C27.7703 39.1522 27.4162 38.7981 26.9793 38.7981Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5211 56.6984V53.2367C53.5211 52.7998 53.167 52.4457 52.7301 52.4457H41.1696C40.7327 52.4457 40.3785 52.7998 40.3785 53.2367V56.6984C40.3785 57.1353 40.7327 57.4894 41.1696 57.4894H52.7301C53.167 57.4894 53.5211 57.1353 53.5211 56.6984Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.877 48.7156V45.2539C69.877 44.817 69.5228 44.4629 69.0859 44.4629H57.5254C57.0885 44.4629 56.7344 44.817 56.7344 45.2539V48.7156C56.7344 49.1525 57.0885 49.5066 57.5254 49.5066H69.0859C69.5228 49.5066 69.877 49.1525 69.877 48.7156Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.877 29.3481V25.8864C69.877 25.4495 69.5228 25.0953 69.0859 25.0953H57.5254C57.0885 25.0953 56.7344 25.4495 56.7344 25.8864V29.3481C56.7344 29.7849 57.0885 30.1391 57.5254 30.1391H69.0859C69.5228 30.1391 69.877 29.7849 69.877 29.3481Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.234 52.6321C34.1652 53.5227 30.6742 56.6504 30.6812 61.0485C30.6812 62.1126 30.6812 64.1762 32.1789 65.2555C33.6765 66.3348 36.0906 66.0254 37.3668 64.6801C39.0074 62.9551 38.1777 60.1438 37.484 58.8583C36.9672 57.9032 36.5465 57.8305 35.9851 56.7829C35.1683 55.2583 35.139 53.6926 35.234 52.6321Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumbingSystemActive);
export default __webpack_public_path__ + "static/media/plumbingSystemActive.075314f147b4af34cc8287eacd89537f.svg";
export { ForwardRef as ReactComponent };